// extracted by mini-css-extract-plugin
export default {"control":"Control_control__Olgup","button":"Control_button__dcEH9"};